import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from '../../../../../javascript/bca/theme'

define([
  "globals",
  "jquery",
  "knockout",
  "header-view-model",
  'axios',
  "lozad",
  "scroll-to-top",
  "modules/enews/enews",
  "slick-nav",
  "internal-user-sticky",
  "accordion",
  "tabs"],
function (globals, $, ko, HeaderViewModel, axios, lozad) {
  var duplicatedMenu = $(".bdc-menu").clone();

  // Remove Sales menu
  duplicatedMenu.find(".bdc-menu-sale").remove();

  // Remove unnecessary level on Brand Menu Item
  duplicatedMenu.find(".bdc-menu-brand").find(".bdc-menu-3rd").find("li")
    .appendTo(duplicatedMenu.find(".bdc-menu-brand").find(".bdc-menu-2nd"));
  duplicatedMenu.find(".bdc-menu-brand").find(".bdc-menu-2nd li:first-child").remove();

  var slickNavLoaded = false;

  if ($(".bdc-header").length > 0) {
    var headerViewModel = new HeaderViewModel();
    ko.applyBindings(headerViewModel, $(".bdc-header").get(0));
  }

  duplicatedMenu.slicknav({
    label: "",
    duration: 100,
    duplicate: false,
    closedSymbol: "+",
    openedSymbol: "-",
    prependTo: ".bdc-header",
    init: function() {
      if (!slickNavLoaded) {
        $("#mobile-top-header").remove();
        // Clone Header Links (Only Get Help and Order Tracking)
        var headerLinks = $(".bdc-header-links ul li.bdc-header-links-show-mobile").clone();
        headerLinks.appendTo(".slicknav_nav");
        $(".slicknav_menu").prepend("<a href='/' class='bdc-vector bdc-logo-negative' title='Blinds.ca'></a>")
                           .prepend("<a href='tel:" + globals.contactNumber + "' class='bdc-font bdc-font-phone'></a>")
                           .prepend("<a href='/Ordering/Cart' class='bdc-font bdc-font-cart'><span class='bdc-badge bdc-badge-attention' data-testid='header-cart-count' data-bind='text: cartItemCount, visible: cartItemCount() > 0' style='display:none;'></span></a>");
        slickNavLoaded = true;
      }
    }
  });

  lozad(document.querySelector('#bca-footer'), {
    rootMargin: '200px 0px',
    loaded: (obj) => {
      let footerEndpoint = `${window.location.protocol}//${window.location.host}`;
      footerEndpoint += '/Home/GetPageSection/?Requestedpage=~/Infopages/Sites/Blinds.ca/Partials/_footer.cshtml';
      axios.get(footerEndpoint).then(({ data }) => {
        const footer = document.createElement('div');
        footer.innerHTML = data.trim();
        obj.insertAdjacentElement('afterend', footer);
        import(/* webpackChunkName: 'footer_bca' */ '../../../../../javascript/bca/footer').then((module) => {
          const getFooterData = module.default;
          getFooterData();
        });
      });
    },
  }).observe();

  import(/* webpackChunkName: "modals" */ '../../../../../javascript/_shared/modals').then((module) => {
    const Modals = module.default;
    ReactDOM.render(<ThemeProvider theme={theme}><Modals /></ThemeProvider>, document.getElementById('bca-modals'));
  });

});
